import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Clock, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ContactPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    t
  } = useLanguage();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <div className="pt-20" data-id="element-425">
      {/* Hero */}
      <div className="bg-caces-navy text-white py-16" data-id="element-426">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-427">
          <h1 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-428">
            {t.contact.hero.title}
          </h1>
          <p className="text-xl text-caces-light max-w-2xl mx-auto" data-id="element-429">
            {t.contact.hero.subtitle}
          </p>
        </div>
      </div>

      <section className="py-16 bg-white" data-id="element-430">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-431">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-432">
            {/* Contact Form */}
            <div data-id="element-433">
              <h2 className="font-serif text-2xl font-bold text-caces-navy mb-6" data-id="element-434">
                {t.contact.form.title}
              </h2>

              {isSuccess ? <div className="bg-green-50 border border-green-100 rounded-xl p-8 text-center" data-id="element-435">
                  <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" data-id="element-436" />
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-437">
                    {t.contact.form.success.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-438">{t.contact.form.success.desc}</p>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-439">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-440">
                    <div data-id="element-441">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-442">
                        {t.contact.form.name}
                      </label>
                      <input type="text" id="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none transition-shadow" placeholder={t.contact.form.namePh} data-id="element-443" />
                    </div>
                    <div data-id="element-444">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-445">
                        {t.contact.form.email}
                      </label>
                      <input type="email" id="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none transition-shadow" placeholder={t.contact.form.emailPh} data-id="element-446" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-447">
                    <div data-id="element-448">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-449">
                        {t.contact.form.phone}
                      </label>
                      <input type="tel" id="phone" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none transition-shadow" placeholder={t.contact.form.phonePh} data-id="element-450" />
                    </div>
                    <div data-id="element-451">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-452">
                        {t.contact.form.subject}
                      </label>
                      <select id="subject" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none transition-shadow" data-id="element-453">
                        <option data-id="element-454">{t.contact.form.subjects.patient}</option>
                        <option data-id="element-455">{t.contact.form.subjects.coordination}</option>
                        <option data-id="element-456">{t.contact.form.subjects.specialist}</option>
                        <option data-id="element-457">{t.contact.form.subjects.general}</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-458">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-459">
                      {t.contact.form.message}
                    </label>
                    <textarea id="message" rows={5} required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none transition-shadow" placeholder={t.contact.form.messagePh} data-id="element-460"></textarea>
                  </div>

                  <Button type="submit" size="lg" isLoading={isSubmitting} data-id="element-461">
                    {t.contact.form.btn}
                  </Button>
                </form>}
            </div>

            {/* Contact Info */}
            <div data-id="element-462">
              <h2 className="font-serif text-2xl font-bold text-caces-navy mb-6" data-id="element-463">
                {t.contact.info.title}
              </h2>
              <div className="bg-gray-50 rounded-xl p-8 space-y-8" data-id="element-464">
                <div className="flex items-start gap-4" data-id="element-465">
                  <div className="bg-white p-3 rounded-full shadow-sm text-caces-accent" data-id="element-466">
                    <MapPin size={24} data-id="element-467" />
                  </div>
                  <div data-id="element-468">
                    <h3 className="font-bold text-caces-navy mb-1" data-id="element-469">
                      {t.contact.info.address}
                    </h3>
                    <p className="text-gray-600" data-id="element-470">
                      Colonia Escalón
                      <br data-id="element-471" />
                      San Salvador, El Salvador
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-472">
                  <div className="bg-white p-3 rounded-full shadow-sm text-caces-accent" data-id="element-473">
                    <Phone size={24} data-id="element-474" />
                  </div>
                  <div data-id="element-475">
                    <h3 className="font-bold text-caces-navy mb-1" data-id="element-476">
                      {t.contact.info.phone}
                    </h3>
                    <p className="text-gray-600" data-id="element-477">+503 2222-0000</p>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-478">
                      {t.contact.info.phoneDesc}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-479">
                  <div className="bg-white p-3 rounded-full shadow-sm text-caces-accent" data-id="element-480">
                    <Mail size={24} data-id="element-481" />
                  </div>
                  <div data-id="element-482">
                    <h3 className="font-bold text-caces-navy mb-1" data-id="element-483">
                      {t.contact.info.email}
                    </h3>
                    <p className="text-gray-600" data-id="element-484">info@caces.com.sv</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-485">
                  <div className="bg-white p-3 rounded-full shadow-sm text-caces-accent" data-id="element-486">
                    <Clock size={24} data-id="element-487" />
                  </div>
                  <div data-id="element-488">
                    <h3 className="font-bold text-caces-navy mb-1" data-id="element-489">
                      {t.contact.info.hours}
                    </h3>
                    <p className="text-gray-600" data-id="element-490">{t.contact.info.hoursDesc}</p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="mt-8 bg-gray-200 rounded-xl h-64 flex items-center justify-center relative overflow-hidden group" data-id="element-491">
                <div className="absolute inset-0 bg-gray-300 flex items-center justify-center" data-id="element-492">
                  <MapPin size={48} className="text-gray-400" data-id="element-493" />
                </div>
                <div className="bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg z-10" data-id="element-494">
                  <span className="font-medium text-caces-navy" data-id="element-495">
                    {t.contact.info.map}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}